import {
  GetProcessDetailDocument,
  GetProcessDetailQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ProcessDetail } from 'modules/processes/domain'

export const useProcessDetail = (variables: GetProcessDetailQueryVariables) => {
  const { data, loading } = useQuery(GetProcessDetailDocument, { variables })

  const process = data?.processes.process

  const transformedProcess: ProcessDetail | undefined = process
    ? {
        ...process,
        steps: process?.steps.map((step) => ({
          ...step,
          items: step?.items
            .map((item) => {
              if (!item) return null
              const {
                position,
                id,
                taskConfiguration,
                action,
                configurationId,
                configurationType,
                stepId,
                itemAssignee,
              } = item

              const commonItem = {
                id,
                configurationId,
                configurationType,
                stepId,
                position: position,
                itemAssignee,
              }

              if (action) {
                const title =
                  action.title ||
                  (action.configuration ? JSON.parse(action.configuration).subject : '')
                const actionTitle = title ? `: ${title}` : ''

                return {
                  ...commonItem,
                  title: `${action.actionConfiguration?.title}${actionTitle}`,
                  configurationIdentifier: action.configurationIdentifier,
                  configuration: action.configuration,
                  files: action.files,
                }
              }

              if (taskConfiguration)
                return {
                  ...commonItem,
                  instruction: taskConfiguration.instruction,
                  mandatory: taskConfiguration.mandatory,
                  offsetAmount: taskConfiguration.offsetAmount,
                  offsetDirection: taskConfiguration.offsetDirection,
                  referenceFieldKey: taskConfiguration.referenceFieldKey,
                  taskType: taskConfiguration.taskType,
                  taskTypeConfiguration: taskConfiguration.taskTypeConfiguration,
                  title: taskConfiguration.title,
                }
            })
            .filter(Boolean),
        })),
      }
    : undefined

  return {
    loading: !process || loading,
    process: transformedProcess,
  }
}
